var Playlists = require("./Playlists"),
    kind      = require("enyo/kind");

require("./TabContent.less");

module.exports = kind(/** @lends app.ArtistPage.TabContent.prototype */ {

    /**
     * @private
     */
    name: "app.ArtistPage.TabContent",

    /**
     * @private
     */
    classes: "app-artist-page-tab-content",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * @private
     */
    components: [{
        name:    "playlists",
        kind:    Playlists,
        classes: "app-artist-page-tab-content__playlists"
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".state",
        to:   ".$.playlists.state"
    }]

});
